export type WorkplaceErrorField = 'name' | 'code' | 'parent';

/**
 * The API answers a failed validation with one sentence that carries the attribute name in
 * English whatever the locale of the rest is ("... Name ...", "... Code ..."), so the field
 * can be told apart even though the wording cannot. The form itself already blocks an empty
 * name and a parent from the unit's own subtree, so what is left for name and code is the
 * uniqueness rule.
 */
export const workplaceErrorField = (error: unknown): WorkplaceErrorField | undefined => {
  const { code, message } = (error || {}) as { code?: string; message?: string };
  if (code !== 'VALIDATION_FAILED' || !message) {
    return undefined;
  }
  if (/\bname\b/i.test(message)) {
    return 'name';
  }
  if (/\bcode\b/i.test(message)) {
    return 'code';
  }
  if (/\bparent\b/i.test(message)) {
    return 'parent';
  }
  return undefined;
};
